import { State } from 'src/types'
import { webOfNormalPocket, webOfShallowPocket, webTop } from './web'

export const webDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)

  if (isShallowWebModel) {
    webOfShallowPocket(ctx, state.web.color, state.stitch.color)
    webTop(ctx, state.web.color, state.stitch.color)
  }

  if (!isShallowWebModel) {
    webOfNormalPocket(ctx, state.web.color, state.stitch.color)
    webTop(ctx, state.web.color, state.stitch.color)
  }
}
